import React from 'react'
import { connect } from 'react-redux'
import has from 'lodash/has'
import { withRouter } from 'react-router-dom'
import { actionCreators } from '@/store/Help'
import Icon from '@/components/Icon'
import Resx from '@/components/Resx'

function mapStateToProps (state, ownProps) {
  const path = ownProps.match.path
  return {
    path,
    show: has(state.help.pages, path)
  }
}

const mapDispatchToProps = {
  load: actionCreators.load,
  toggle: actionCreators.toggle
}

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
class HelpButton extends React.Component {
  componentDidMount () {
    const { load, path } = this.props
    load(path)
  }

  toggle = e => {
    const { toggle, path } = this.props
    e.preventDefault()
    toggle(path)
  }

  render () {
    const { show } = this.props
    return show
      ? <a className='help-button btn btn-sm btn-primary' onClick={this.toggle}><span>
        <Resx name='Common.Help' /></span><Icon name='help-circle' /></a>
      : null
  }
}

export {
  HelpButton
}



// WEBPACK FOOTER //
// ./src/components/help/helpButton.js